import { GetSurfaceQueryParams } from '../../models/surface.model';

const surfaceKeys = {
    all: (params?: GetSurfaceQueryParams) => [
        'surface',
        ...Object.values(params || {}),
    ],
    getSurface: (surfaceId: string) => ['surface', surfaceId],
    getSurfacePresets: () => ['surface', 'presets'],
};

export default surfaceKeys;
